import { QueryClient } from '@tanstack/react-query';

const createAppQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
      },
    },
  });

export default createAppQueryClient;
